import dealer from './dealer'
import region from './region'
import store from './store'
import storeType from './storeType'
import salesMan from './salesman'
export default {
  cmc: {
    base: {
      ...dealer,
      ...region,
      ...store,
      ...storeType,
      ...salesMan
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/cmc/cmc.js